var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.218 4.85734H6.85537C6.68623 4.85777 6.51884 4.89155 6.36277 4.95674C6.2067 5.02194 6.06502 5.11726 5.94582 5.23726C5.82663 5.35726 5.73226 5.49958 5.66812 5.65608C5.60398 5.81259 5.57133 5.9802 5.57203 6.14934V12.8747C5.57203 13.588 6.1467 14.1667 6.85537 14.1667H12.218C12.3872 14.1662 12.5546 14.1325 12.7106 14.0673C12.8667 14.0021 13.0084 13.9068 13.1276 13.7868C13.2468 13.6668 13.3411 13.5244 13.4053 13.3679C13.4694 13.2114 13.5021 13.0438 13.5014 12.8747V6.14934C13.5014 5.436 12.9267 4.85734 12.218 4.85734Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4281 4.85734V3.12534C10.4281 2.78267 10.2928 2.454 10.0521 2.212C9.9333 2.0922 9.79197 1.99707 9.63625 1.93208C9.48054 1.86709 9.31351 1.83354 9.14478 1.83334H3.78211C3.44211 1.83334 3.11545 1.96934 2.87545 2.212C2.63459 2.45502 2.49925 2.78319 2.49878 3.12534V9.85067C2.49878 10.1933 2.63411 10.522 2.87478 10.764C3.11545 11.006 3.44145 11.1427 3.78211 11.1427H5.57211",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.de5deb9ed68b6f58017b42d39ef29da9.svg";
export { ForwardRef as ReactComponent };